import React from "react";
import { Controller } from "react-hook-form";
import { FormControl, FormHelperText, Typography } from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

const PhoneInputField = ({
  name = "phone",
  control,
  label = "Phone Number",
  rules = {},
  country = "ae", // default country code (Egypt in this case)
  ...rest
}) => {
  return (
    <FormControl fullWidth>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <>
            <PhoneInput
              country={country}
              enableSearch={true}
              value={value}
              onChange={(phone) => onChange(phone)}
              variant="outlined"
              label={label}
              inputStyle={{
                width: "100%",
                height: "32px",
                border: error
                  ? "1px solid red"
                  : "1px solid rgba(0, 0, 0, 0.23)",
                borderRadius: "1px",
                fontSize: "16px",
                backgroundColor: "transparent",
                boxShadow: "none",
                "&:hover": {
                  borderColor: "rgba(0, 0, 0, 0.87) !important",
                },
                "&:focus": {
                  borderColor: "rgba(0, 0, 0, 0.87) !important",
                },
                "&:focus": {
                  borderColor: "red !important",
                },
              }}
              buttonStyle={{
                borderRadius: "1px",
                fontSize: "16px",
                backgroundColor: "transparent",
              }}
              containerStyle={{
                width: "100%",
              }}
              {...rest}
            />
            {error && <FormHelperText error>{error.message}</FormHelperText>}
          </>
        )}
      />
    </FormControl>
  );
};

export default PhoneInputField;
